import { useCallback } from 'react';
import useApi from '../hooks/useApi';
import { callNuatalker } from '../lib/nuaApi';

const normalizeProfilesResponse = (response) => {
  if (Array.isArray(response)) {
    return { profiles: response };
  }
  if (Array.isArray(response?.profiles)) {
    return { profiles: response.profiles };
  }
  if (Array.isArray(response?.results)) {
    return { profiles: response.results };
  }
  return { profiles: [] };
};

export const usePlatformProfileService = () => {
  const { callApi } = useApi();

  const listProfiles = useCallback(async () => {
    try {
      const response = await callNuatalker({
        path: '/platform/profiles',
        method: 'GET',
        callApi,
      });
      return { success: true, data: normalizeProfilesResponse(response) };
    } catch (error) {
      console.error('Error fetching platform profiles:', error);
      return {
        success: false,
        error: error.message || 'Error al obtener los perfiles genéricos',
      };
    }
  }, [callApi]);

  const saveProfile = useCallback(async (payload) => {
    try {
      const response = await callNuatalker({
        path: '/platform/profiles',
        method: 'POST',
        body: payload,
        callApi,
      });
      return { success: true, data: response };
    } catch (error) {
      console.error('Error saving platform profile:', error);
      return {
        success: false,
        error: error.message || 'Error al guardar el perfil genérico',
      };
    }
  }, [callApi]);

  return {
    listProfiles,
    saveProfile,
  };
};

export default usePlatformProfileService;
